<div id="add-simulation-type" class="add-simulation-type-cotainer position-relative">
    <span class="close-icon-add-simulation-type" style="cursor: pointer" (click)="onCloseModal()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.26211 15.9621L0.0371094 14.7371L6.77461 7.99961L0.0371094 1.26211L1.26211 0.0371094L7.99961 6.77461L14.7371 0.0371094L15.9621 1.26211L9.22461 7.99961L15.9621 14.7371L14.7371 15.9621L7.99961 9.22461L1.26211 15.9621Z"
                fill="#ACACAC"
            />
        </svg>
    </span>
    <div class="box-header">
        <h2 class="font-bold m-0">{{ 'CreateOrUpdateSimulation.AddNewSimulationType' | translate }}</h2>
    </div>
    <div class="form">
        <form novalidate [formGroup]="simulateTypeForm" (ngSubmit)="clickAddSimulationType()">
            <div class="form-field w-100" appearance="fill">
                <label class="label">{{ 'CreateOrUpdateSimulation.NameOfSimulationType' | translate }}</label>
                <input
                    maxlength="100"
                    type="text"
                    class="input-text w-100"
                    formControlName="name"
                    placeholder="{{ 'CreateOrUpdateSimulation.EnterNameSimulationType' | translate }}"
                    [ngClass]="
                        nameCtrl.hasError('required') && (nameCtrl.touched || nameCtrl.dirty) ? 'input-error' : ''
                    "
                    required

                />
                <mat-error *ngIf="nameCtrl.hasError('required') && (nameCtrl.touched || nameCtrl.dirty)">{{
                    'ValidationMessage.RequiredNameSimulationType' | translate
                }}</mat-error>
            </div>
            <div class="form-field w-100" appearance="fill">
                <label class="label">{{ 'Description' | translate }}</label>
                <textarea
                    type="text"
                    maxlength="1000"
                    class="input-text w-100 description"
                    formControlName="description"
                    placeholder="{{ 'EnterDescription' | translate }}"
                    [ngClass]="
                        descriptionCtrl.hasError('required') && (descriptionCtrl.touched || descriptionCtrl.dirty)
                            ? 'input-error'
                            : ''
                    "
                    required
                ></textarea>
                <mat-error
                    *ngIf="descriptionCtrl.hasError('required') && (descriptionCtrl.touched || descriptionCtrl.dirty)"
                    >{{ 'ValidationMessage.RequiredDescription' | translate }}</mat-error
                >
            </div>

            <button
                mat-button
                class="btn-add-simulation-type font-bold btn-common-style float-right"
                (click)="clickAddSimulationType()"
            >
                {{ 'CreateOrUpdateSimulation.AddSimulationType' | translate }}
            </button>
        </form>
    </div>
</div>
